import { Box, Container, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useConfig } from 'src/core/config';

const FooterWrapper = styled(Box)(
  ({ theme }) => `
        border-radius: 0;
        margin: ${theme.spacing(3)} 0;
`
);

export default function Footer() {
  const { name, description } = useConfig();
  const year = new Date().getFullYear();

  return (
    <FooterWrapper>
      <Container maxWidth="xl">
        <Box
          py={3}
          display={{ xs: 'block', md: 'flex' }}
          alignItems="center"
          textAlign={{ xs: 'center', md: 'left' }}
          justifyContent="space-between"
        >
          <Box>
            <Typography variant="subtitle1">
              &copy; {year} - {name} {description ? `- ${description}` : ''}
            </Typography>
          </Box>
        </Box>
      </Container>
    </FooterWrapper>
  );
}

